<template>
  <div class="cancelOrder" :class="{ isiOSX: isiOSX }">
    <van-nav-bar
      title="选择取消原因"
      class="nav_bar_body"
      left-arrow
      @click-left="reBack"
    />
    <div class="cancel_Body">
      <p class="cause">请告知我们取消原因，我们会努力改善～</p>
      <van-radio-group v-model="radio">
        <van-cell-group :border="false">
          <van-cell
            v-for="item in radioList"
            :key="item.value"
            :title="item.label"
            class="radio_text"
            clickable
            :border="false"
          >
            <van-radio
              icon-size="20px"
              checked-color="#0FBF6D"
              slot="right-icon"
              :name="item.label"
            />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="submit_body">
      <van-button type="default" @click="handleSubmit()" class="submit_btn"
        >确认取消</van-button
      >
    </div>
  </div>
</template>

<script>
import "@/assets/hotel/css/reset.css";
import { getCancel } from "@/pages/hotel/api";
import orderList from "./orderList.vue";
export default {
  data() {
    return {
      radio: undefined,
      radioList: [
        {
          label: "行程取消",
          value: 1,
        },
        {
          label: "信息填错",
          value: 2,
        },
        {
          label: "预订时间太长",
          value: 3,
        },
        {
          label: "酒店质量太差",
          value: 4,
        },
        {
          label: "其他",
          value: 5,
        },
      ],
      id: this.$route.query.order_sn,
      routing: this.$route.query.routing,
      active: this.$route.query.active || 0,
    };
  },

  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
  },
  components: {},
  methods: {
    handleSubmit() {
      if (!this.radio) return this.$toast("请选择取消理由~");
      getCancel({
        order_sn: this.id,
        cancel_reason: this.radio === "其他" ? this.radio + "原因" : this.radio,
      })
        .then((res) => {
          this.$toast("取消成功~");
          if (this.routing === "list") {
            this.$router.push({
              path: "/hotel/myOrder",
              query: {
                active: this.active,
              },
            });
          } else if (this.routing === "detail") {
            this.$router.push({
              path: "/hotel/orderDetail",
              query: {
                order_sn: this.id,
                routing:'detail'
              },
            });
          } else {
            this.$router.push({
              path: "/hotel/statusDetail",
              query: {
                order_sn: this.id,
              },
            });
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    reBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less">
.van-radio__icon--checked .van-icon-success::before {
  content: "";
  display: inline-block;
  background: url("../../../assets/hotel/img/order/select.png");
  background-size: 100% 100%;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
}
.van-icon-success::before {
  content: "";
  display: inline-block;
  background: url("../../../assets/hotel/img/order/unSelect.png");
  background-size: 100% 100%;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
}
.van-icon {
  border: none !important;
}
.van-hairline--bottom::after{
  border-bottom-width:0;
}
</style>
<style lang="less" scoped>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.cancelOrder {
  font-weight: 600;
  background-color: #ffffff;
  //   height: 100%;
  padding-top: 4.4rem;
  .cancel_Body {
    width: calc(100% - 2rem);
    margin: 0 auto;
    .cause {
      color: #666;
      font-size: 1.6rem;
      margin: 1rem 0 2rem;
      font-weight: 400;
      padding: 0 16px;
    }
    .radio_text {
      font-size: 1.6rem;
      color: #333;
    }
    .cancal_text {
      background: #eeeeee;
      border-radius: 0.6rem;
      font-size: 1.5rem;
      margin-top: 1rem;
      margin-bottom: 10rem;
    }
  }
  .submit_body {
    width: 100%;
    height: 8.8rem;
    box-shadow: 0 0 0.6rem 0.2rem #eaeaea;
    position: fixed;
    bottom: 0;
    background: #fff;
    .submit_btn {
      width: calc(100% - 1.5rem);
      margin: 1rem auto;
      display: block;
      border-radius: 1.8rem;
      height: 4rem;
      font-size: 1.6rem;
      line-height: 4rem;
      background: linear-gradient(135deg, #0fbf6d 0%, #108b30 100%);
      color: #fff;
      outline: none;
      border: none;
    }
  }
  .nav_bar_body {
    // padding-top: 44rem;
  }
  .van-cell {
    line-height: 23px;
    padding: 13px 16px;
  }
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
  font-size: 1.8rem;
}
.isiOSX {
  padding-top: 44px;
}
/deep/ .van-icon{
    margin: 0 0.3rem 0 0;
    bottom: 0.1rem;
    position: relative;
}
</style>
